/**
 * Canonical product catalog for JC3 Wealth Legacy Group.
 *
 * Six products only. `slug` is the Airtable table this product's records live
 * in (unchanged for backward-compat). `key` is the billing-engine identifier.
 * `route` is the sidebar destination.
 *
 * Compliance framing: JC3 is a financial consulting firm. Nothing about
 * account access, tradeline placement, or credit-bureau disputes appears in
 * any product name, description, or invoice line item.
 */
export const PRODUCTS = [
  {
    key:  "financial_profile_development",
    name: "Financial Profile Development",
    slug: "credit",
    route: "/financial-profile-development",
    billingModel: "setup_plus_recurring",
    summary: "Personal financial profile education & strategy.",
  },
  {
    key:  "personal_capital_strategy",
    name: "Personal Capital Strategy",
    slug: "personal-funding",
    route: "/personal-capital-strategy",
    billingModel: "contingency",
    summary: "Personal capital strategy consulting.",
  },
  {
    key:  "business_capital_strategy",
    name: "Business Capital Strategy",
    slug: "business-funding",
    route: "/business-capital-strategy",
    billingModel: "contingency",
    summary: "Business capital strategy consulting.",
  },
  {
    key:  "profile_positioning_services",
    name: "Account History Positioning",
    slug: "tradelines",
    route: "/profile-positioning-services",
    billingModel: "per_unit",
    summary: "Adds clients as authorized users on established accounts.",
  },
  {
    key:  "grant_readiness_and_funding_research",
    name: "Grant Readiness & Research",
    slug: "grants",
    route: "/grant-readiness-and-funding-research",
    billingModel: "base_plus_per_unit",
    summary: "Research base fee + per-application guidance.",
  },
  {
    key:  "business_foundation_and_entity_setup",
    name: "Business Foundation Setup",
    slug: "llc",
    route: "/business-foundation-and-entity-setup",
    billingModel: "base_plus_pass_through",
    summary: "Formation setup + state fees at cost.",
  },
];

export const productBySlug = Object.fromEntries(PRODUCTS.map((p) => [p.slug, p]));
export const productByKey  = Object.fromEntries(PRODUCTS.map((p) => [p.key, p]));

export const canonicalName = (key) => productByKey[key]?.name || key;
